import { render, staticRenderFns } from "./edit-secondhand.vue?vue&type=template&id=609c1816&scoped=true&"
import script from "./edit-secondhand.vue?vue&type=script&lang=ts&"
export * from "./edit-secondhand.vue?vue&type=script&lang=ts&"
import style0 from "./edit-secondhand.vue?vue&type=style&index=0&id=609c1816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c1816",
  null
  
)

component.options.__file = "edit-secondhand.vue"
export default component.exports